export const filetype = 'RDFSXFM2'
export const fileName = 'RDFSXFN'
export const fileSize = 'RDFSXSZ'
export const crc = 'RDFSXCR'
export const reboot = 'RDFSXRB0'
export const data = 'RDFD'
export const execute = 'JSCMXES'
